<template>
  <section
    class="colour-card"
    :style="isMozzarella && 'border: 2px solid grey;'"
  >
    <div
      class="colour-card__top"
      :class="content.class"
      :style="isOrange && 'border: 2px solid white;'"
    >
      <img
        :src="require(`../assets/images/colour-${content.class}.png`)"
        v-if="content.image"
      />
    </div>
    <div
      class="colour-card__bottom"
      :style="isMozzarella && 'border-top: 2px solid grey;'"
    >
      <h5 class="colour-card__bottom--title">{{ content.name }}</h5>
      <p class="colour-card__bottom--subtitle">{{ content.type }}</p>
      <div class="colour-card__bottom--details">
        <div v-for="(detail, i) in content.details" :key="`detail_${i}`">
          <span>{{ detail.name }}</span>
          <p>{{ detail.code }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ColourCard',
  props: {
    content: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  computed: {
    isOrange() {
      return this.content.class === 'orange'
    },
    isMozzarella() {
      return this.content.class.includes('mozzarella')
    },
  },
}
</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.colour-card {
  width: 100%;
  border-radius: 30px;
  -webkit-box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.05) 0px 8px 32px;
  -moz-box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.05) 0px 8px 32px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.05) 0px 8px 32px;
  &__top {
    border-radius: 30px 30px 0 0;
    height: 200px;
    display: flex;
    justify-content: center;
    @media (max-width: $tablet) {
      height: 100px;
    }
    img {
      height: 250px;
      margin-top: -60px;
      @media (max-width: $tablet) {
        height: 150px;
        margin-top: -30px;
      }
    }
  }
  &__bottom {
    border-radius: 0 0 30px 30px;
    padding: 10px;
    background-color: var(--color-mozzarella-3);
    &--title {
      color: var(--color-charcoal-1);
    }
    &--subtitle {
      margin-top: -20px;
      color: var(--color-charcoal-1);
    }
    &--details {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      justify-content: space-between;
      div {
        width: 48%;
        margin: 1%;
      }
      span {
        color: var(--color-charcoal-2);
        font-size: 14px;
      }
      p {
        font-size: 10px;
        color: var(--color-charcoal-1);
        background-color: var(--color-white-1);
        padding: 10px;
        text-align: center;
        border-radius: 30px;
      }
    }
  }
}
</style>